module.exports = __webpack_public_path__ + "static/media/icon_goed.3d233e42.svg";